<template>
  <div>
    <div class="xes-1v1-auth">

      <h2>授权通知</h2>

      <span
        class="xes-1v1-auth-content">因业务调整,1对1后续服务由学而思APP承接,为保证您在新平台正常学习和使用,我们需要您授权共享您的用户数据,以便我们可以在学而思APP上继续为您服务。</span>
      <br>

      <span class="xes-1v1-auth-subtitle">授权数据范围:</span>
      <br>

      <span class="xes-1v1-auth-content">用户手机号,学员编号,城市,年级</span>
      <br>

      <span class="xes-1v1-auth-subtitle">数据使用目的:</span>
      <br>

      <span class="xes-1v1-auth-content">创建学而思APP账户,以便您在新平台使用服务</span>
      <br>
    </div>
     <div class="xes-1v1-auth-bottom-btn">
          <button class="xes-1v1-auth-cancel" v-if="isShowBtn" @click="cancelAuth">
            不同意
          </button>
          <button class="xes-1v1-auth-ok" @click="goAuth">
            同意授权
          </button>
        </div>
    <div id="loadingToast" class="loading_toast" v-show="loading">
      <div class="loading_mask_transparent"></div>
      <div class="gif-loading"></div>
    </div>
  </div>

</template>

<script>
import { Toast } from "vant";
import getAccessToken from "@/utils/getToken";
import getUserInfo from "@/utils/getUserInfo";

// import appUtil from "@/utils/appUtil";
export default {

  data() {
    return {
      user_uid: 0,
      user_grade: 0,
      user_city_code: 0,
      user_city_name: 0,
      user_grade_name: 0,
      user_real_name: 0,
      user_avatar_url: 0,
      loading: false,
      isShowBtn: false
    }
  },
  created(){
    console.log("lsj", this.$route)
    this.isShowBtn = !!this.$route.query.client
    localStorage.setItem("isShowBtn",this.isShowBtn)
  },
  methods: {

    optCancel() {

      let tempUid = localStorage.getItem("talUid")
      let tempGrade = localStorage.getItem("talUserGrade")
      let tempCity = localStorage.getItem("talUserCity")
      let params = {
        action: 1, // 1 拒绝
        channel: "app",
        grade_id: parseInt(tempGrade), // 10 11 12
        city_code: tempCity,
        uid: parseInt(tempUid)
      }
      this.$api.clueTeacherForm.authSubmit(params).then(() => {
        this.loading = false
        window.dhsdk.finishInterface({
          success: () => {

          },
          fail: () => {
          },
        });
      })
    },
    cancelAuth() {
      this.loading = true
      getAccessToken().then(async (token) => {
        //
        if (token && token !== "undefined") {

          let userInfo = await getUserInfo();
          if (Object.keys(userInfo).length > 0) {
            localStorage.setItem("talUid", userInfo.uid)
            localStorage.setItem("talUserGrade", userInfo.gradeId)
            localStorage.setItem("talUserCity", userInfo.cityCode)
          }
          this.optCancel()
        } else if (localStorage.getItem("talToken") && localStorage.getItem("talToken") !== "undefined") {
          this.optCancel()
        } else {
          window.dhsdk.finishInterface({
            success: () => {
            },
            fail: () => {
            },
          });
        }

      })

    },

    getTalUserInfo() {

      let tempUid = localStorage.getItem("talUid")
      // 获取用户信息
      let userParams = {
        "uid": tempUid
      }
      this.$api.clueTeacherForm.getUserInfo(userParams).then((res) => {
        if (res.error_code === 0) {
          this.user_uid = parseInt(res.result.uid)
          this.user_grade_name = res.result.grade_name
          this.user_grade = res.result.grade
          this.user_grade_name = res.result.grade_name
          this.user_real_name = res.result.real_name
          this.user_city_code = res.result.city_code
          this.user_city_name = res.result.city_code_name
          this.getFamily()
        } else {
          this.loading = false
          Toast(res.message)

        }
      })

    },
    getFamily() {
      this.$api.clueTeacherForm.getFamilyList().then((res) => {

        if (res.error_code === 0) {
          if (JSON.stringify(res) !== "{}") {
            let familyList = []
            if (res.result) {
              familyList = res.result.list
            }
            if (familyList.length <= 0) {
              // 选择学员
              familyList.push({
                uid: this.user_uid,
                grade: this.user_grade,
                grade_name: this.user_grade_name,
                city_code: this.user_city_code,
                city_code_name: this.user_city_name,
                avatar_url: this.user_avatar_url,
                real_name: this.user_real_name,
              })
            }

            let str = JSON.stringify(familyList)

            localStorage.setItem("talFamily", str)
            this.$router.push({
              path: "/auth/SelectStu",
              query: {
                familyList: familyList
              }
            });
          }
        } else {
          this.loading = false
          Toast('请求异常，请重试')
        }
      });
    },

    goAuth() {
      // 跳转到授权页面
      // 校验登录态 有登录态就跳转到授权页面

      // let util = new appUtil()
      // let isApp = util.isApp()
      // console.log('isApp = ' + isApp)
      this.loading = true
      getAccessToken().then(async (token) => {
        //
        if (token && token !== "undefined") {
          localStorage.setItem("talToken", token)

          let userInfo = await getUserInfo();
          if (Object.keys(userInfo).length > 0) {
            localStorage.setItem("talUid", userInfo.uid)
            this.getTalUserInfo()
          } else {
            this.loading = false
          }
        } else {
          this.loading = false
          this.$router.push({
            path: "/auth/loginCode"
          });
        }
      })
    },

  },

}
</script>
<style lang="scss" scoped>
.xes-1v1-auth {
  margin: 0 20px 0 20px;
}

.xes-1v1-auth-subtitle {
  color: #0f1114;
  font-size: 16px;
  font-weight: bold;
}
.xes-1v1-auth-bottom-btn {
  position: fixed;
  bottom: 50px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  padding: 0 24px 0 24px;
  .xes-1v1-auth-cancel {
    width: 103px;
    font-size: 16px;
    border-radius: 24px;
    margin-right: 10px;
    background-color: #F3F5F5;
    color: black;
    height: 44px;
    align-content: center;
  }

  .xes-1v1-auth-ok {
    flex: 1;
    font-size: 16px;
    border-radius: 24px;
    background-color: red;
    color: white;
    height: 44px;
    align-content: center;
  }
}

h2 {
  text-align: center;
  font-size: 16px;
  margin-top: 20px;
  font-weight: bold;
  color: #000C1D;
}

.xes-1v1-auth-content {

  font-size: 13px;
  color: #565d66;
  display: block;
}

span {
  margin-top: 18px;
  font-size: 18px;
}
</style>